<template>
  <div id="HolterAnalysisRequest">
    <section>
      <div id="container-center">
        <h1 style="" class="title has-text-centered printTarget">ホルター心電図解析申込み</h1>
        <div>
          <b-steps v-model="activeStep" :animated="true" :rounded="true" :has-navigation="false" label-position="bottom">
            <b-step-item step="1" label="利用規約" icon="comment-alert-outline" v-if="needAgree">
              <div id="item-contens">
                <div class="request-title">
                  <b-button class="is-primary" style="float:left;" icon-left="home" @click.prevent="goHome">ホーム画面</b-button>
                  <b-button class="is-primary" style="float: right" icon-right="chevron-double-right" :disabled="!isChecked" @click.prevent="Forward">次へ</b-button>
                  <span>以下の利用規約に同意のうえ、申込みを行ってください。</span>
                </div>
                <div class="card-content margin-top">
                  <span style="font-size:20px;">利用規約</span>
                  <table>
                    <tr><td><textarea readonly class="cautionArea noresize" v-model="agreement"/></td></tr>
                    <tr>
                        <td>
                          <div style="text-align: center;">
                            「<a :href="getUrlPrivacyPolicy()" target="_blank" rel="noopener noreferrer">プライバシー規則</a>」は<a :href="getUrlPrivacyPolicy()" target="_blank" rel="noopener noreferrer" style="font-weight: bold;color:yellowgreen">こちら</a>を参照してください。
                          </div>
                       </td>
                    </tr>
                    <tr><td><div style="text-align: center;"></div></td></tr>
                    <tr><td><div style="text-align: center;"><b-checkbox class="cstmCheckBox" v-model="isChecked" :disabled="!canAgree">利用規約に同意のうえ、申込みを行う。</b-checkbox></div></td></tr>
                  </table>
                </div>
              </div>
            </b-step-item>
            <b-step-item step="2" label="依頼内容" icon="pulse">
              <div id="item-contens">
                <div class="request-title">
                  <b-button v-if="needAgree" class="is-primary" style="float:left;" icon-left="chevron-double-left" @click.prevent="Backward">前へ</b-button>
                  <b-button v-else class="is-primary" style="float:left;" icon-left="home" @click.prevent="goHome">ホーム画面 </b-button>
                  <b-button class="is-primary" style="float: right" icon-right="chevron-double-right" :disabled="!isHospitalAgree" @click.prevent="Forward">次へ</b-button>
                  <span>ホルター心電図解析依頼の情報を入力してください。</span>
                </div>
                <div class="card-content margin-top">
                  <table>
                     <tr><th>医療機関名<span class="require" v-if="isDealer || isHonsha || isAdmin || isSalesOffice"/></th>
                      <td>
                        <template v-if="isDealer || isHonsha || isAdmin || isSalesOffice">
                          <input type="text" style="width:730px;" v-model="reqParams.hospitalName" disabled class="2" name="医療機関名" validate="required"/>
                          <b-button style="margin-left:10px; width:150px; height:27px;" @click="organizationModalActive=true">医療機関選択</b-button>
                        </template>
                        <template v-else>{{reqParams.hospitalName}}</template>
                      </td>
                    </tr>
                    <tr><th>医師名</th><td><input type="text" v-model="reqParams.doctorName" maxlength="105"/></td></tr>
                    <tr><th>事務担当者名</th><td><input type="text" v-model="reqParams.clerkName" maxlength="100"/></td></tr>
                    <template v-if="isDealer || isHonsha || isAdmin || isSalesOffice">
                      <tr><th>医療機関メールアドレス</th><td><b-checkbox class="cstmCheckBox" v-model="reqParams.isResultMailSend">解析結果のダウンロードURLを医療機関にメールで通知する。</b-checkbox></td></tr>
                      <tr v-if="reqParams.isResultMailSend"><th></th><td><input type="text" v-model="reqParams.hospitalMail" placeholder="例）example@example.com" class="2" name="医療機関メールアドレス" validate="mail|required"></td></tr>
                    </template>
                    <tr><th>解析方法<span class="require" /></th>
                      <td>
                        <select id="analysisMethod" v-model="reqParams.analysisMethod" @change="changedAnalysisMethod" class="2" name="解析方法" validate="required">
                          <option v-for="method in analysisMethodList" :value="method.value" :key="method.value">{{ method.label1 }}</option>
                        </select>
                      </td>
                    </tr>
                    <tr><th>解析オプション<span class="require"/></th>
                      <td><select v-model="reqParams.analysisOption" name="解析オプション" @change="changedAnalysisOption" class="2" validate="required">
                        <option v-for="analysisOption in analysisOptionList" :value="analysisOption.value" :key="analysisOption.value">{{ analysisOption.label1 }}</option>
                        </select></td>
                    </tr>
                    <tr v-if="reqParams.judgmentFlag"><th>判定医</th><td><b-checkbox class="cstmCheckBox" v-model="reqParams.judgment">前回と違う判定医に依頼する。</b-checkbox></td></tr>
                    <tr><th>最短返却可能日</th><td>{{reqParams.shortestReturnDate}}</td></tr>
                    <tr v-if="reqParams.canUseUrgent"><th>お急ぎ便利用</th><td><b-checkbox class="cstmCheckBox" v-model="urgentConvenience">お急ぎ便を利用する。</b-checkbox></td></tr>
                    <tr id="tr_urgency_caution" v-if="reqParams.canUseUrgent && urgentConvenience">
                      <th></th>
                      <td>
                        <div class="urgency_caution">
                          ・お急ぎ便は緊急の場合のみご利用ください。 <br />
                          ・お急ぎ便を指定した場合でもご希望の返却希望日に沿えない場合がございます。<br />
                          ・上記に同意される場合、下記チェックと理由をご記入ください。
                        </div>
                        お急ぎ便利用理由<span class="require"/><textarea v-model="reqParams.urgentConvenienceReasons" class="2" name="お急ぎ便利用理由" validate="required" maxlength="256" style="resize:vertical;max-width:100%;"></textarea>
                        <b-checkbox value="false" class="cstmCheckBox" v-model="precautionsAgree" id="precautionsAgree">お急ぎ便利用時の注意事項に同意する。<span class="require" /></b-checkbox><br /><br />
                      </td>
                    </tr>
                    <tr><th>返却希望日<span class="require" /></th><td><input type="date" v-model="reqParams.returnDate" style="width:150px;" class="2" name="返却希望日" validate="required|date" disabled/><a @click="officeCalenderActive = true"><b-icon icon="calendar-cursor"></b-icon></a></td></tr>
                    <tr><th></th><td><div>※17時以降のお申し込みは、翌営業日受付となります。</div></td></tr>
                    <tr><th>備考</th><td><textarea v-model="reqParams.biko" maxlength="256" style="resize:vertical;max-width:100%;"></textarea></td></tr>
                    <tr><th class="deliverySlip_label">納品書</th>
                      <td>
                        <div>
                          <b-radio class="td_radio deliverySlip_radio" name="deliverySlip" v-model="reqParams.deliverySlip" :native-value="true" disabled="disabled">必要</b-radio>
                          <b-radio class="td_radio deliverySlip_radio" name="deliverySlip" v-model="reqParams.deliverySlip" :native-value="false" disabled="disabled">不要</b-radio>
                        </div>
                      </td>
                    </tr>
                    <tr><th>デモ</th><td><b-checkbox class="cstmCheckBox" v-model="reqParams.demo">デモ(トライアル)</b-checkbox></td></tr>
                    <template v-if="isDealer">
                      <tr/>
                      <tr>
                        <th/><td><b-checkbox class="cstmCheckBox" v-model="isHospitalAgree">申請者が{{analysisType}}の申込みを行うことについて、該当医療機関の同意を取得しています。</b-checkbox></td>
                      </tr>
                    </template>
                  </table>
                </div>
              </div>
            </b-step-item>
            <b-step-item step="3" label="患者情報設定" icon="account">
              <div id="item-contens">
                <div class="request-title">
                  <b-button class="is-primary" style="float: left" icon-left="chevron-double-left" @click.prevent="Backward">前へ</b-button>
                  <span>患者の情報を入力してください。</span>
                  <b-button class="is-primary" style="float: right" icon-right="chevron-double-right" @click.prevent="Forward">次へ</b-button>
                </div>
                <div class="card-content margin-top">
                  <table>
                    <tr><th>診察券ID（患者ID）<span class="require"/></th><td><input type="text" v-model="reqParams.patientId" maxlength="50" class="3" name="診察券ID（患者ID）" validate="required" /></td></tr>
                    <tr><th>患者名<span class="require" /></th><td><input type="text" v-model="reqParams.patientName" class="3" name="患者名" validate="required" maxlength="100"/></td></tr>
                    <tr><th>患者名（カナ）</th><td><input type="text" v-model="reqParams.patientNameKana" class="3" name="患者名（カナ）" validate="kana" maxlength="100"/></td></tr>
                    <tr><th>性別<span v-if='true' class="require" /></th>
                      <td>
                        <div>
                          <b-radio class="td_radio genderCheck" name="gender" v-model="reqParams.gender" native-value="-">-</b-radio>
                          <b-radio class="td_radio genderCheck" name="gender" v-model="reqParams.gender" native-value="男">男</b-radio>
                          <b-radio class="td_radio genderCheck" name="gender" v-model="reqParams.gender" native-value="女">女</b-radio>
                        </div>
                      </td>
                    </tr>
                    <tr><th>生年月日</th><td><input type="date" v-model="reqParams.birthday" :input="inputBirthday()" class="3" name="生年月日" validate="date|birthDay" :max="yyyy_hyp_MM_hyp_dd(new Date())" style="width:150px;" id="birthDay"/><span v-if="reqParams.birthday" style="margin-left:10px;">{{reqParams.japaneseCalendar}}</span></td></tr>
                    <tr><th>年齢</th><td><input type="text" disabled v-model="reqParams.age"/></td></tr>
                    <tr><th>基礎疾患・合併症<span v-if="reqParams.judgmentFlag" class="require" /></th><td><input type="text" v-model="reqParams.basicIllnessComplications" maxlength="256" class="3" name="基礎疾患・合併症" :validate="`${reqParams.judgmentFlag ? 'required' : ''}`"/></td></tr>
                    <tr><th>投薬状況<span v-if="reqParams.judgmentFlag" class="require" /></th><td><input type="text" v-model="reqParams.dosingStatus" maxlength="256" class="3" name="投薬状況" :validate="`${reqParams.judgmentFlag ? 'required' : ''}`"/></td></tr>
                    <tr><th>主訴<span v-if="reqParams.judgmentFlag" class="require" /></th><td><input type="text" v-model="reqParams.chiefComplaint" maxlength="256" class="3" name="主訴" :validate="`${reqParams.judgmentFlag ? 'required' : ''}`"/></td></tr>
                    <tr><th>備考</th><td><textarea v-model="reqParams.patientBiko" maxlength="256" style="resize:vertical;max-width:100%;"/></td></tr>
                  </table>
                </div>
              </div>
            </b-step-item>
            <b-step-item step="4" label="解析データ情報" icon="file-find">
              <div id="item-contens">
                <div class="request-title">
                  <b-button class="is-primary" style="float: left" icon-left="chevron-double-left" @click.prevent="Backward">前へ</b-button>
                  <span>解析を依頼するデータの情報を入力してください。</span>
                  <b-button class="is-primary" style="float: right" icon-right="chevron-double-right" @click.prevent="Forward">次へ</b-button>
                </div>
                <div class="card-content margin-top">
                  <table>
                    <tr><th>検査目的<span v-if="true" class="require" /></th>
                      <td>
                        <select v-model="reqParams.analysisDataInfo.inspectionPurpose" validate="required">>
                          <option v-for="inspectionPurpose in inspectionPurposeList" :value="inspectionPurpose.value" :key="inspectionPurpose.value">{{ inspectionPurpose.label1 }}</option>
                        </select>
                      </td>
                    </tr>
                    <tr><th>備考</th><td><textarea v-model="reqParams.analysisDataInfo.biko" maxlength="256" style="resize:vertical;max-width:100%;"></textarea></td></tr>
                    <tr><th>添付データ<span class="require" /></th>
                      <td>
                        <div class="hsrReq_upload_area" @dragenter="dragEnter">
                          <span class="upload_span">ここに添付する解析データを「フォルダごと、ドラッグアンドドロップ」してください。<br>「ファイルを追加」から添付する場合は、事前に検査データを圧縮の上、添付ください。</span>
                        </div>
                      </td>
                      <b-modal :active.sync="isUpdateModal" has-modal-card  >
                        <div class="modal-card uploadModal" 
                          @dragleave="dragLeave"
                          @drop.prevent="fileDrop"
                        >
                            ここに解析データファイルをドロップします。
                        </div>
                      </b-modal>
                    </tr>
                    <tr><th></th>
                      <td>
                        <b-upload v-model="upButtonFile"  class="file-label" v-on:input="addUploadfile" multiple>
                          <span class="file-cta">
                            <span class="file-label">ファイルを追加</span>
                          </span>
                        </b-upload>
                      </td>
                    </tr>
                    <tr><th></th><td>
                        <table>
                          <template v-for="(upfile,index) of upFiles">
                            <tr :key="index">
                              <td style="width: 20px"><b-icon icon="paperclip" /></td><td style="width: 400px">{{upfile.path}}</td><td><a @click="deleteUpfile(index)"><b-icon icon="delete-forever-outline " /></a></td></tr>
                          </template>
                        </table>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </b-step-item>
            <b-step-item step="5" label="申込み" icon="cloud-upload">
              <div id="item-contens">
                <div class="request-title">
                  <b-button class="is-primary" style="float: left" icon-left="chevron-double-left" @click.prevent="Backward">前へ</b-button>
                  <span>以下の申込み内容を確認のうえ、下部の「申込みを完了する」ボタンを押下してください。</span>
                </div>
                <!--　ホルター解析申込み詳細 -->
                <holterRequestDetail ref="comfirmDetails" :key="reset" v-bind:data="reqParams"/>
                <b-button class="is-primary" style="margin-top:5px; width:250px;" :disabled="compleateFlg" @click="requestHolterAnalysis">申込みを完了する</b-button>
              </div>
            </b-step-item>
            <b-step-item step="6" label="完了" icon="check" :type="{ 'is-success': true }">
              <section class="unPrintTarget">
                <div class="request-title"><span>ホルター心電図解析の申込みを受け付けました。</span></div>
                <div class="request-title" v-if="needAgree"><span style="color:red;">翌営業日までに登録済みメールアドレスへ申し込み完了メールが送信されます。</span></div>
                <div class="margin-top">
                  <b-button class="backbutton is-primary" @click="back">戻る</b-button>
                  <b-button class="printbutton is-primary" icon-left="printer" @click="print">印刷</b-button>
                </div>
              </section>
              <section class="printTarget printMargin">
                <div id="item-contens">
                  <div class="card-content margin-top">
                    <table>
                      <tr><th>受付日時</th><td>{{requestDate}}</td></tr>
                      <tr><th>受付番号</th><td>{{receiptNumber}}</td></tr>
                    </table>
                  </div>
                </div>
                <holterRequestDetail ref="finishDetails" :key="reset" v-bind:data="reqParams"/>
              </section>
            </b-step-item>
          </b-steps>
        </div>
      </div>
    </section>
    <b-modal :active.sync="organizationModalActive" has-modal-card>
      <organizationSelectModal v-if="isHonsha || isAdmin || isSalesOffice" :selectRole="[role.role_hospital]" :selectStatus="extUserStatus.registed" title="医療機関選択" labelForOrg="医療機関名" @select="setOrganization"></organizationSelectModal>
      <facilitySelectModal v-if="isDealer" :dealerId="userId" @select="setfacility"></facilitySelectModal>
    </b-modal>
    <b-modal :active.sync="officeCalenderActive" has-modal-card>
      <officeCalenderModal :miniday="new Date(reqParams.shortestReturnDate)" @select="setReturnDate"></officeCalenderModal>
    </b-modal>
  </div>
</template>
<script>
import {role} from "@/components/mock/base/const.js";
import {consentStatement} from "@/components/mock/base/const.js";
import {UploadType} from "@/components/mock/base/const.js";
import {choicesType} from "@/components/mock/base/const.js";
import {extUserStatus} from "@/components/mock/base/const.js";
import {analysisOption} from "@/components/mock/base/const.js";
import {holterAnalysisMethod} from "@/components/mock/base/const.js";
import holterRequest from "@/components/mock/common/HolterAnalysisRequestDetail";
import OrganizationSelectModal from "@/components/mock/philips/common/OrganizationSelectModal";
import FacilitySelectModal from "@/components/mock/philips/common/FacilitySelectModal";
import OfficeCalenderModal from "@/components/mock/guest/OfficeCalenderModal";
export default {
  name: "HolterAnalysisRequest",
  methods: {
    Backward: function() {
      this.activeStep -= 1;
    },
    Forward: async function(event) {
      // バリデーションチェック
      var stepItems = document.getElementsByClassName("step-item")
      var target
      for(var item of stepItems){
        if(item.getAttribute("style") != "display: none;"){
          target = item
        }
      }
      var activeStep = target ? target.getAttribute("step") : ""
      if(activeStep){
        var elements = document.getElementsByClassName(activeStep)
        var result = this.selfMadeValidation(elements)
        var errMsg = result.msg
        if(activeStep+""=="2" && this.reqParams.urgentConvenience+"" == "true"){
          var element = document.getElementById("precautionsAgree");
          element.children[1].style["border-color"] = "";
          if(this.precautionsAgree+"" != "true"){
            errMsg = errMsg + "お急ぎ便利用時の注意事項同意チェックは必須項目です。\n"
            element.children[1].style["border-color"] = "red";
          }
        }else if (activeStep+""=="3"){

        }else if (activeStep+""=="4"){
          if (activeStep+""=="4" && this.upFiles.length==0){
            errMsg = errMsg + "添付データが選択されていません。\n"
          }else{
            let nameList = this.upFiles.map(item => item['path']);
            for(let i =0; i < nameList.length; i++){
              if(nameList[i].startsWith("/")){
                //フォルダの場合はzip名にしてチェック
                nameList[i] = nameList[i].replace("/", "") + ".zip"
              }
            }
            const setElements = new Set(nameList);
            if (setElements.size !== nameList.length) {
              errMsg = errMsg + "添付データの重複しているファイルが存在します。\n"
            } else {
              let sizeOK = await this.checkUploadFileSize(this.upFiles);
              if(!sizeOK){
                errMsg = errMsg + "2GBを超えるファイルはアップロードできません。\n"
              }
            }
          }      
        }
        if(result.isError){
          this.showErrorMessage(errMsg)
        }else if (errMsg != ""){
          this.showErrorMessage(errMsg)
        }else{
          this.activeStep += 1;
        }
      }
    },
    inputBirthday: function(){
      var age = this.getAge(this.reqParams.birthday)
      if(!isNaN(Number(age))){
        this.reqParams.age = age < 0 ? 0 : age
        const date = new Date(this.reqParams.birthday);
        const options = {era: 'long'};
        this.reqParams.japaneseCalendar  = "【"+this.getJapaneseCalendar(date)+"】"
      }else{
        this.reqParams.age = ""
      }
    },
    changedAnalysisMethod: function() {
      this.reqParams.canUseUrgent = this.reqParams.analysisMethod == this.holterAnalysisMethod.one
      this.urgentConvenience = false
      this.reqParams.urgentConvenienceReasons = ""
      this.precautionsAgree = false
    },
    changedAnalysisOption: function() {
      this.reqParams.judgmentFlag = this.reqParams.analysisOption == this.analysisOption.includedAll

      if(this.reqParams.analysisOption == this.analysisOption.included){
        this.reqParams.returnDate = ""
        this.reqParams.shortestReturnDate = this.yyyy_sla_MM_sla_dd(this.getBusinessDay(new Date(), 2 + this.includeToday)) //申請日を含んで5営業日後
      }else{
        this.reqParams.returnDate = ""
        this.reqParams.shortestReturnDate = this.yyyy_sla_MM_sla_dd(this.getBusinessDay(new Date(), 4 + this.includeToday)) //申請日を含んで5営業日後
      }
    },
    requestHolterAnalysis: async function() {
      var messsage =
        this.analysisType +
        "の解析を申込みます。<br/>申込み内容に間違いがないことを確認して「OK」ボタンを押してください。";
      this.$dialog.confirm({
        title: "申込み確認",
        message: messsage,
        cancelText: "修正する",
        onConfirm: async () => {
          this.compleateFlg = true
          try{
            // WebAPI Call
            let _this = this;
            let isApplicationSuccess = false;
            await this.apiCall(
              function(client){
                var obj = JSON.parse(JSON.stringify(_this.reqParams));
                obj.returnDate = obj.returnDate.replace(/-/g, "/")
                obj.birthday = obj.birthday ? obj.birthday.replace(/-/g, "/") : ""
                obj.age = obj.age + ""
                obj.belongsId = _this.belongsId
                if (!obj.isResultMailSend) {
                  obj.hospitalMail = _this.defaultMail
                }
                
                return client.apis.externalHolterAnalysis.setHAnalysisApplicationPOST({
                  body:obj
                });
              },
              function(result){
                _this.requestDate = result.obj.requestDate
                _this.receiptNumber = result.obj.receiptNumber
                isApplicationSuccess = true;
              },
              function(result) {
                _this.showErrorMessage(result);
                isApplicationSuccess = false;
              },
            );
            // 申請が成功したらファイルをアップロードする
            if(isApplicationSuccess){
             this.multipleUpload(this.upFiles ,this.receiptNumber, this.UploadType.holter_report, "ホルター解析データ")
             .then(result => {
               _this.finishHolterAnalysisApplication();
             }).catch(error =>{
               _this.showErrorMessage("ファイルアップロードに失敗した為、申込みをキャンセルしました。<br>再度実行してください。");
             });
            }
          }finally {
            this.compleateFlg = false;
          }
        } 
      });
    },
    finishHolterAnalysisApplication: function() {
      let _this = this;
      this.apiCall(
        function(client){
          return client.apis.externalHolterAnalysis.finishHAnalysisApplicationPOST({
            body:{receiptNumber:_this.receiptNumber}
          });        
        },
        function(result){
          _this.showMessage("登録が完了しました。");
          _this.jumpToTop();
          _this.$refs.finishDetails.getDetail(_this.receiptNumber); //子コンポーネントに更新を伝達
          _this.activeStep += 1;
        },
        function(result){
          _this.showErrorMessage(result);
        }
      );
    },
    back: function() {
      this.$router.go(-1);
    },
    goHome: function() {
      this.back();
    },
    setOrganization: function(organizationInfo){
      this.reqParams.belongsId = organizationInfo.id + "";
      this.reqParams.hospitalName = organizationInfo.orgName;
      if (!this.belongsId || this.belongsId != organizationInfo.id) {
        // 代理申込時
        this.belongsId = organizationInfo.id
      }
      
      if(!this.reqParams.hospitalMail){
        this.reqParams.hospitalMail = organizationInfo.mail
        this.defaultMail = organizationInfo.mail
      }
      // 前回申込み情報の取得
      this.prevPsgSearchParam.belongsId = this.belongsId
      this.getPreviousApplication()
    },
    setfacility: function(facility){
      this.reqParams.institutionId = facility.id + "";
      this.reqParams.hospitalName = facility.orgName;

      // 前回申込み情報の取得
      this.prevPsgSearchParam.institutionId = facility.id
      this.getPreviousApplication()
    },
    setReturnDate: function(selectDate){
      this.reqParams.returnDate = selectDate
      this.officeCalenderActive = false;
    },
    print: function(){
      window.print();
    },
    dragEnter: function() {
      this.isUpdateModal = true;
    },
    dragLeave: function() {
      this.isUpdateModal = false;
    },
    fileDrop: async function(event) {
      for(let i =0 ; i < event.dataTransfer.items.length; i++){
        const item = event.dataTransfer.items[i];
        const entry = item.webkitGetAsEntry();
        let path = entry.name;
        if(entry.isDirectory){
          path = entry.fullPath;
        }
        this.upFiles.push({ file: entry, path: path });
        this.reqParams.analysisDataInfo.attachedDataFileList.push({ name: path });
      }
      this.$refs.comfirmDetails.updateAattachedDataFileList(); //子コンポーネントに更新を伝達
      this.isUpdateModal = false;
    },

    addUploadfile: function(){
      for(let upFile of this.upButtonFile){
        this.upFiles.push({ file: upFile, path: upFile.name })
        this.reqParams.analysisDataInfo.attachedDataFileList.push({  name: upFile.name });
      }
      this.$refs.comfirmDetails.updateAattachedDataFileList(); //子コンポーネントに更新を伝達
      this.upButtonFile = [];
    },
    deleteUpfile: function(index){
      this.upFiles.splice(index, 1);
      this.reqParams.analysisDataInfo.attachedDataFileList.splice(index, 1);
      this.$set(this.reqParams.analysisDataInfo,"attachedDataFileList",this.reqParams.analysisDataInfo.attachedDataFileList)
      this.$refs.comfirmDetails.updateAattachedDataFileList(); //子コンポーネントに更新を伝達
    },
    getAgreementStr: async function() {
      var excuteApi = this.getConsentStatementPOST;
      var successCallBack = this.getConsentStatementPOSTSuccess;
      var errorCallBack = this.getConsentStatementPOSTError;
      // WebAPI Call
      await this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getConsentStatementPOST: function(client) {
      var type = this.consentStatement.holter_analysis_hospital;
      if(this.isDealer){
        type = this.consentStatement.holter_analysis_dealer;
      }
      return client.apis.apiCommon.getConsentStatementPOST({
         body: {
           type: type
         } 
      });
    },
    getConsentStatementPOSTSuccess: function(result) {
      if(result.body.contents != ""){
        this.agreement = result.body.contents;
        this.canAgree = true;
      } else {
        this.agreement = "利用規約が登録されていません。";
      }

    },
    getConsentStatementPOSTError: function(result) {
      this.agreement == "利用規約を取得できませんでした。";
    },
    getChoicesList: async function() {
      this.analysisMethodList = this.getChoiceList(this.choicesType.holterMethod, false);
      this.analysisOptionList = this.getChoiceList(this.choicesType.holterAnalysisOp, false);
      this.inspectionPurposeList = this.getChoiceList(this.choicesType.holterInspectionPurpose, false);
      
      this.analysisMethodList.unshift({})
      this.analysisOptionList.unshift({})
      this.inspectionPurposeList.unshift({})
    },
    getPreviousApplication: async function() {
      var excuteApi = this.getPreviousApplicationDetailsPOST;
      var successCallBack = this.getPreviousApplicationDetailsPOSTSuccess;
      var errorCallBack = this.getPreviousApplicationDetailsPOSTError;
      // WebAPI Call
      await this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getPreviousApplicationDetailsPOST: function(client) {
      return client.apis.apiCommon.getPreviousApplicationDetailsPOST({
        body: this.prevPsgSearchParam
      });
    },
    getPreviousApplicationDetailsPOSTSuccess: function(result) {
      this.reqParams.doctorName = result.body.doctorName
      this.reqParams.analysisMethod = result.body.analysisMethod
      this.reqParams.analysisOption = result.body.analysisOption
      // 最短出荷日の変更
      this.reqParams.returnDate = ""
      this.reqParams.shortestReturnDate = this.yyyy_sla_MM_sla_dd(this.getBusinessDay(new Date(), 4 + this.includeToday)) //申請日を含んで5営業日後
    },
    getPreviousApplicationDetailsPOSTError: function(result) {
      // 取得失敗時
    }
  },
  data() {
    var analysisType = "ホルター心電図";
    var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    var roleId = userInfo.roleId;
    var userId = userInfo.id;
    var isDealer = roleId == role.role_dealer;
    var isSalesOffice = roleId == role.role_salesOffice;
    var isHospital = roleId == role.role_hospital;
    var isHonsha = roleId == role.role_headOffice;
    var isAdmin = roleId == role.role_admin;
    var includeToday = this.isBusinessDay(new Date()) ? 0 : 1;
    return {
      role: role,
      UploadType:UploadType,
      choicesType:choicesType,
      extUserStatus: extUserStatus,
      holterAnalysisMethod:holterAnalysisMethod,
      analysisOption:analysisOption,
      userId: userId,
      belongsId:userInfo.belongsId,
      isDealer: isDealer,
      isSalesOffice: isSalesOffice,
      isHonsha: isHonsha,
      isAdmin: isAdmin,
      organizationModalActive: false,
      isHospitalAgree: !isDealer,
      isChecked: false,
      agreement: "",
      activeStep: 0,
      analysisType: analysisType,
      reqParams:{
        isNotHospital: !isHospital,
        hospitalName:isHospital ? userInfo.medicalInstitutionName + " " + userInfo.departmentName : "",
        doctorName:"",
        clerkName:"",
        isResultMailSend: false,
        hospitalMail:"",
        analysisMethod:"",
        analysisOption:"",
        canUseUrgent:false,
        judgmentFlag:false,
        judgment:false,
        // 解析のみ3営業日、その他は5営業日
        shortestReturnDate: this.yyyy_sla_MM_sla_dd(this.getBusinessDay(new Date(), 5)),
        urgentConvenience:false,
        urgentConvenienceReasons:"",
        deliverySlip:false,
        demo:false,
        patientId:"",
        patientName:"",
        patientNameKana:"",
        gender:"",
        birthday:"",
        japaneseCalendar:"",
        age:"",
        dosingStatus:"",
        chiefComplaint:"",
        biko:"",
        patientBiko:"",
        institutionId: "",
        analysisDataInfo:{
          inspectionPurpose:"",
          biko:"",
          attachedDataFileList:[]
        }
      },
      upFiles: [],
      upButtonFile:null,
      isUpdateModal: false,
      compleateFlg:false,
      requestDate:"",
      receiptNumber:"",
      precautionsAgree:false,
      officeCalenderActive: false,
      urgentConvenience:false,
      needAgree: isHospital || isDealer,
      canAgree:false,
      consentStatement:consentStatement,
      analysisMethodList:[],
      analysisOptionList:[],
      inspectionPurposeList:[],
      reset: 0,
      includeToday: includeToday,
      defaultMail: "",
      prevPsgSearchParam:{
        belongsId:userInfo.belongsId,
        institutionId:0,
      },
      isHospital
    };
  },
  computed: {},
  components: {
    organizationSelectModal:OrganizationSelectModal,
    facilitySelectModal:FacilitySelectModal,
    holterRequestDetail: holterRequest,
    officeCalenderModal:OfficeCalenderModal
  },
  watch: {
  },
  async mounted() {
    //同意文取得
    await this.getAgreementStr();
    // 機種マスタ取得
    await this.getChoicesList();
    if(this.isHospital){
      // 前回申込み情報の取得
      this.getPreviousApplication()
    }
  }
};
</script>

<style lang="scss">
.urgency_caution {
  color: red;
  margin-left: 10px;
}
.uploadModal {
  width: 900px !important;
  height:500px !important;
  display: grid !important;
  place-items: center !important;
}
.hsrReq_upload_area {
  height: 60px !important;
  line-height: 30px;
  border: 2px dotted;
  text-align: center;
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/components/mock/guest/HolterAnalysisRequest.vue